import { Modal } from '@/components/Modal';
import type { ModelLink } from '@maker-toolchest/shared';
import { LinksTable } from './LinksTable';

interface ModelLinksModalProps {
  open: boolean;
  onClose: () => void;
  modelName: string;
  links: ModelLink[];
}

export function ModelLinksModal({ open, onClose, modelName, links }: ModelLinksModalProps) {
  return (
    <Modal open={open} onClose={onClose} title={`Links - ${modelName}`} size="lg">
      <div className="space-y-4">
        <LinksTable links={links} />
      </div>
    </Modal>
  );
}
